import Vue from 'vue'
import Vuex, { Module, Plugin } from 'vuex'
import { IBalancesState } from './client/modules/balances/types'
import { IBookmarksState } from './client/modules/bookmarks/types'
import { IChatNewState } from './client/modules/chat-new/types'
import { IDashboardState } from './client/modules/dashboard/types'
import { GigChatState } from './client/modules/gig-chat/types'
import { IServicesListState } from './client/modules/gig/types'
import { JobChatState } from './client/modules/job-chat/types'
import { IMyGigsState } from './client/modules/my-gigs/types'
import { IMyJobsState } from './client/modules/my-jobs/types'
import { IMyVacanciesState } from './client/modules/my-vacancies/types'
import { IPendingTxsState } from './client/modules/pending-txs/types'
import { ISignState } from './client/modules/sign-process/types'
import { ISignupState } from './client/modules/signup/types'
import { ISnacksState } from './client/modules/snacks/types'
import { IUiState } from './client/modules/ui/types'
import { VacancyChatState } from './client/modules/vacancy-chat/types'
import * as modulesShared from './shared'
import { AppState } from './shared/modules/app/types'
import { IBlogState } from './shared/modules/blog/types'
import { IBrowseFreelancersState } from './shared/modules/browse-freelancers/types'
import { IBrowseJobsState } from './shared/modules/browse-jobs/types'
import { IBrowseVacanciesState } from './shared/modules/browse-vacancies/types'
import { ICustomerDetailsState } from './shared/modules/customer-details/types'
import { IFreelancersState } from './shared/modules/freelancer-details/types'
import { IBrowseGigsState } from './shared/modules/gigs/types'
import { IJobDetailsState } from './shared/modules/job-details/types'
import { ILandingCopyState } from './shared/modules/landing-copy/types'
import { ILandingState } from './shared/modules/landing/types'
import { IRatesState } from './shared/modules/rates/types'
import { ISalaryState } from './shared/modules/salary/types'
import { ISkillsState } from './shared/modules/skills/types'
import { IVacancyDetailsState } from './shared/modules/vacancy-details/types'
import { IVacancyRolesState } from './shared/modules/vacancyRoles/types'

Vue.use(Vuex)

function storeModuleFactoryCreate(factoryModule: { [key: string]: () => Module<any, RootState> }) {
  return Object.entries(factoryModule)
    .map(([key, factory]) => ({ key, value: factory() }))
    .reduce((t, entry) => ({ ...t, [entry.key]: entry.value }), {})
}

export default function () {
  const plugins: Plugin<RootState>[] = []

  const store = new Vuex.Store<RootState>({
    strict: process.env.NODE_ENV === 'development' && (process.client || typeof process.client === 'undefined'),
    modules: {
      ...storeModuleFactoryCreate(modulesShared),
    },
    actions: {
      resetState({ commit }, isLeaveState) {
        const RESET_COMMIT = 'resetState'
        const RESETTABLE_MODULES = [
          'browseJobs',
          'browseVacancies',
          'jobDetails',
          'myJobs',
          'user',
          'balances',
          'freelancerDetails',
          'notifications',
          'dashboard',
          'myVacancies',
          'vacancyDetails',
          'chatNew',
          'myGigs',
          'bookmarks',
          'customerDetails',
        ]
        RESETTABLE_MODULES.forEach((module) => {
          try {
            commit(`${module}/${RESET_COMMIT}`, isLeaveState)
          } catch (e) {
            console.error(e)
          }
        })
      },
    },
    plugins,
  })
  return store
}

export interface RootState {
  // client
  balances: IBalancesState
  bookmarks: IBookmarksState
  chatNew: IChatNewState
  dashboard: IDashboardState
  gig: IServicesListState
  myGigs: IMyGigsState
  myJobs: IMyJobsState
  myVacancies: IMyVacanciesState
  pendingTxs: IPendingTxsState
  signProcess: ISignState
  snacks: ISnacksState
  ui: IUiState

  // shared
  app: AppState
  blog: IBlogState
  browseJobs: IBrowseJobsState
  browseGigs: IBrowseGigsState
  browseVacancies: IBrowseVacanciesState
  browseFreelancers: IBrowseFreelancersState
  customerDetails: ICustomerDetailsState
  freelancerDetails: IFreelancersState
  jobDetails: IJobDetailsState
  landing: ILandingState
  landingCopy: ILandingCopyState
  skills: ISkillsState
  vacancyDetails: IVacancyDetailsState
  vacancyRoles: IVacancyRolesState
  signup: ISignupState
  rates: IRatesState
  salary: ISalaryState
  jobChat: JobChatState
  gigChat: GigChatState
  vacancyChat: VacancyChatState
  [key: string]: any // ToDo: get rid of it, exactly describe
}
